import React, { useState, useEffect } from "react";
import axios from '../apis/Axios';
import { SERVER_URL } from '../apis/Api';

function MainBanner({ onLoaded }) {
    const [image, setImage] = useState(null);
    const imageName = 'home_background.png';

    useEffect(() => {
        const fetchImages = async () => {
            try {
                const res = await axios.get('api/general/images');
                const list = res.data || [];
                const found = list.find(item => item.name === imageName);

                if (found) {
                    setImage(found);
                } else {
                    console.warn(`Image "${ imageName }" not found in images list`);
                }
            } catch (err) {
                console.error('Failed to fetch images list:', err);
            }
        };

        fetchImages();
    }, []);

    const buildFullUrl = (url) => {
        if (!url) return '';
        return `${ SERVER_URL.replace(/\/$/, '')}/${url.replace(/^\/+/, '') }`;
    };

    return (
        <div className="main-banner">
            { image ? (
                <img
                    src={ buildFullUrl(image.url) }
                    alt="Main banner"
                    className="banner-image"
                    onLoad={() => onLoaded?.()}
                    onError={(e) => {
                        console.error('Banner image failed to load:', e?.target?.src);
                    }}
                />
            ) : null }
        </div>
    );
}

export default MainBanner;